module.exports = __webpack_public_path__ + "img/check.9a6dc928.svg";